import { logger } from 'config/logger';
import { truncateForTelemetry } from 'shared/lib/telemetry';
import { type Response as CurrentUser } from 'shared/legacy/hooks/useCurrentUserQuery';
import type { IndeedSubscriptionAdminSource } from './useIndeedConfig.types';

export const logIndeedConfigResolution = ({
  currentUser,
  outcome,
  source,
  indeedEmail,
  creditBalance,
  hasActiveSubscription,
  error,
}: {
  currentUser?: CurrentUser;
  outcome: 'success' | 'failed';
  source: IndeedSubscriptionAdminSource;
  indeedEmail?: string | null;
  creditBalance?: number;
  hasActiveSubscription?: boolean;
  error?: unknown;
}) => {
  try {
    newrelic.addPageAction('IndeedConfigResolution', {
      tenantId: currentUser?.tenant_id ?? '',
      agentIdentifier: currentUser?.id ?? '',
      userEmail: currentUser?.email ?? '',
      rr_user_email: currentUser?.email ?? '',
      outcome,
      source,
      indeedEmail: indeedEmail ?? '',
      creditBalance: creditBalance ?? '',
      hasActiveSubscription: hasActiveSubscription === undefined ? '' : String(hasActiveSubscription),
      error: error instanceof Error ? error.message : error ? String(error) : '',
      timestamp: new Date().toISOString(),
    });
  } catch (loggingError) {
    logger.error(loggingError, { context: 'IndeedConfigResolutionLogging' });
  }
};

export const logIndeedSubscriptionInfoGraphQL = ({
  currentUser,
  outcome,
  responseBody,
  error,
}: {
  currentUser?: CurrentUser;
  outcome: 'success' | 'non_200_response' | 'missing_headers' | 'error';
  responseBody?: unknown;
  error?: unknown;
}) => {
  try {
    newrelic.addPageAction('IndeedSubscriptionInfoGraphQL', {
      tenantId: currentUser?.tenant_id ?? '',
      agentIdentifier: currentUser?.id ?? '',
      outcome,
      responseBody: truncateForTelemetry(responseBody),
      error: error instanceof Error ? error.message : error ? String(error) : '',
      timestamp: new Date().toISOString(),
    });
  } catch (loggingError) {
    logger.error(loggingError, { context: 'IndeedSubscriptionInfoGraphQLLogging' });
  }
};
